import { NavLink } from 'react-router-dom';

const tabs: { to: string; label: string }[] = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/today', label: 'Today' },
  { to: '/calendar', label: 'Calendar' },
  { to: '/training', label: 'Training' },
];

export function Nav() {
  return (
    <nav
      className="fixed inset-x-0 z-20 flex justify-center pointer-events-none"
      style={{ bottom: 'calc(env(safe-area-inset-bottom, 0px) + 14px)' }}
    >
      {/* A frosted white capsule floating on the canvas. The active tab is a
          solid ink pill — the same black that carries every primary action, so
          "where I am" and "what I can press" speak one language. */}
      <div className="pointer-events-auto flex items-center gap-0.5 rounded-full border border-line bg-bg-raised/85 p-1.5 backdrop-blur-2xl shadow-[0_1px_2px_rgba(11,11,15,0.05),0_16px_40px_-16px_rgba(11,11,15,0.26)]">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              `rounded-full px-4 py-2.5 text-xs font-semibold tracking-[-0.005em] transition-colors duration-150 ${
                isActive
                  ? 'bg-accent text-accent-fg'
                  : 'text-fg-muted hover:text-fg hover:bg-fg/[0.05]'
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
